export const formatGoogleMapsDirectionsLink = (address: string): string => {
    return `https://maps.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
        address
    )}`;
};

export const formatGoogleMapsLocationLink = (address: string): string => {
    return `https://www.google.com/maps/place/${encodeURIComponent(address)}`;
};

export default { formatGoogleMapsDirectionsLink, formatGoogleMapsLocationLink };
